import * as React from "react";
import Box from "@mui/material/Box";

/**
 * Connections 
 * ----------------------------------------------------------

 */

// ---------- Component ----------
export default function Connections() {
 
  return (
    <Box sx={{ p: { xs: 2, md: 3 }, bgcolor: 'background.default', minHeight: '100vh' }}>
      <h1>Connections.  Your Princess is in another castle. haha</h1>
    </Box>
  );
}
